import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

const cacheConfig = {
  cacheLocation: "localStorage", // This configures where your cache will be stored
  storeAuthStateInCookie: true, // This configures whether to store cache in cookies
};

const msalConfig = window.location.hostname === "localhost"
  ? {
    // dev settings
    auth: {
      clientId: '667481fe-4165-466f-bb19-6bd25df1afde',
      authority: `https://login.microsoftonline.com/0cdcb8d3-c24e-4401-bc6c-8e265d40fe4e`,
      redirectUri: 'http://localhost:8080', // Your Vue.js app URL
    },
    cache: cacheConfig
  } : {
    // production settings
    auth: {
      clientId: '9d5b05f6-3b68-4edc-897c-8de484d7792d',
      authority: `https://login.microsoftonline.com/0cdcb8d3-c24e-4401-bc6c-8e265d40fe4e`,
      redirectUri: 'https://marketscout.xbyte.com', // Your Vue.js app URL
    },
    cache: cacheConfig
  };

  // console.log('MSAL Config', msalConfig);

const msalInstance = new PublicClientApplication(msalConfig);
const initializePromise = msalInstance.initialize();

export const login = async () => {
  await initializePromise;
  await msalInstance.handleRedirectPromise();
  console.log('Logging in');
  try {
    const loginResponse = await msalInstance.loginRedirect({
      scopes: ['openid', 'profile', `api://${msalConfig.auth.clientId}/Api,User`],
    });
    return loginResponse;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getAccessToken = async () => {
  await initializePromise;
  await msalInstance.handleRedirectPromise();
  console.log('Getting access token');
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    const silentRequest = {
      account: accounts[0],
      scopes: [`api://${msalConfig.auth.clientId}/Api,User`],
    };

    try {
      console.log('Requesting token');
      const silentResponse = await msalInstance.acquireTokenSilent(silentRequest);
      return silentResponse.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        console.log('Interactive token request');
        const interactiveResponse = await msalInstance.acquireTokenRedirect(silentRequest);
        return interactiveResponse.accessToken;
      } else {
        console.error(error);
        return null;
      }
    }
  } else {
    console.log('No accounts');
  }
  return null;
};

export const logout = async () => {
  await initializePromise;
  await msalInstance.handleRedirectPromise();
  console.log('Logging out');
  await msalInstance.logoutRedirect();
};